import { ProfileModel } from "./Profile.model";

export class UserProfileModel {
  Id: number
  IdUsuario: string;
  IdPerfil: string;
  CreadoPor?: string;
  FechaCreacion?: Date;
  ModificadoPor?: string;
  FechaModificado?: Date;
  IdProfileNavigation:ProfileModel;

  UserProfileModel() {
    this.Id = 0;
    this.IdUsuario = "";    
    this.IdPerfil = "";    
    this.CreadoPor = "";
    this.FechaCreacion = new Date;
    this.ModificadoPor = "";
    this.FechaModificado = new Date;
    this.IdProfileNavigation = new ProfileModel();
  }
}
